export default {
  rollover: {
    title: 'Rollover',
    detailsTitle: 'Butiran Rollover',
    all: 'Semua',
    allStats: 'Semua Status',
    select: 'Pilih',
    rolloverType: 'Jenis Rollover',
    amount: 'Jumlah',
    source: 'Sumber',
    wallet: 'Dompet',
    current: 'Semasa',
    wagered: 'Dipertaruhkan',
    required: 'Diperlukan',
    progress: 'Kemajuan',
    loading: 'Memuatkan...',
    noData: 'Tiada data',
    noMoreData: 'Tiada data lagi',
    state: 'Keadaan',
    type: 'Jenis',
    createdOn: 'Dicipta pada',
    wageringRequirement: 'Syarat Pertaruhan',
    currency: 'Mata Wang',
    wagerRequired: 'Pertaruhan Diperlukan',
    wagerCompleted: 'Pertaruhan Selesai',
    cash: 'Tunai',
    bonus: 'Bonus',
  },
};
